import React from "react";
import ColorCell from "./Cells/ColorCell";

// eslint-disable-next-line import/prefer-default-export
export const renderColorCell = (text) => <ColorCell color={text} />;
